import React from 'react';
import EmptyPage from 'app/components/Pages/EmptyPage';
import { MaskLoading } from './GridLayout';
import { Table } from 'clad';

const GridTable = props => {
    const {
        loading,
        records,
        columns,
        searchString,
        emptyPage,
        fetching,
        rowKey,
        onCreate,
        widthGrid,
        widthColumns,
        total,
        redirect
    } = props;

    const handleCreate = () => {
        onCreate();
    };

    const gridTable = () => {
        if (loading) return <MaskLoading />;
        if (records !== null && records.length > 0) {
            return (
                <Table
                    columns={columns}
                    dataSource={records}
                    showHeader={true}
                    style={{ padding: '0px 40px 40px 40px' }}
                    rowKey={rowKey || 'id'}
                    pagination={false}
                    loading={fetching}
                    scroll={
                        widthGrid > widthColumns
                            ? { x: 0 }
                            : { x: widthColumns }
                    }
                />
            );
        }
        if (fetching) return <MaskLoading />;
        if (!redirect && Boolean(total) && records.length === 0) {
            return <EmptyPage type={'no-results'} size="medium" />;
        }
        return searchString === null || searchString === '' ? (
            <EmptyPage
                type={emptyPage}
                size="medium"
                actionBtn={onCreate ? handleCreate : null}
            />
        ) : (
            <EmptyPage type={'no-results'} size="medium" />
        );
    };

    return gridTable();
};

export default GridTable;
